import remote from './remote'

const URL = {
    GET_MENU: '/cms/menu'
}

export default {
    getMenu () {
        return remote.request({
            url: remote.getUrl(URL.GET_MENU)
        })
    }
}
